// extracted by mini-css-extract-plugin
module.exports = {"dynamicContent":"az_huc","title":"az_iuc","label":"az_juc"};